module.exports = __webpack_public_path__ + "static/media/country_ke.cf688643.webp";